import React, { ReactNode } from "react";
import {ApolloProvider} from "react-apollo";
import {client} from "./client";

interface WrapRootElementProps {
    element: ReactNode;
}

export const wrapRootElement = ({element}: WrapRootElementProps) => {
    return (
        <ApolloProvider client={client}>
            {element}
        </ApolloProvider>
    )
}